// The "Common Questions from Participants" on /for-participants (English only, like the page). The page renders
// these and its FAQPage structured data is built from the same list (src/lib/seo/structuredData.ts).

export interface FaqItem {
  q: string;
  a: string;
}

export const PARTICIPANT_FAQ: FaqItem[] = [
  {
    q: "How quickly are photos available?",
    a: "Most photographers upload and process photos within hours of the event. Some galleries go live while you're still at the venue!",
  },
  {
    q: "Do I need to create an account?",
    a: "No account needed to browse or search. Simply visit the event gallery, search for your photos, and purchase directly.",
  },
  {
    q: "What image quality do I get?",
    a: "You receive the full-resolution, unwatermarked original photo. Perfect for printing, sharing on social media, or keeping as a digital memory.",
  },
  {
    q: "Can I find photos from past events?",
    a: "Yes! Photos from past events remain available in our galleries. Search by event name, location, or date to find your memories.",
  },
];
